export enum BillingPolicy {
  SUM_HOURS = "Sum Hours" as any,
  SUM_HOURS_WITH_MINIMUM = "Sum Hours With Minimum" as any,
}

/** Enum name from the API and the billing-policy select. The enum member is the label. */
export const SUM_HOURS_WITH_MINIMUM_KEY = BillingPolicy[BillingPolicy.SUM_HOURS_WITH_MINIMUM] as string;
